(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var Q = String.fromCharCode(34);

    function esc(value) {
      return String(value)
        .split('&').join('&amp;')
        .split('<').join('&lt;')
        .split('>').join('&gt;')
        .split(Q).join('&quot;');
    }

    function attr(value) {
      return Q + esc(value) + Q;
    }

    function init() {
      var section = document.querySelector('#nt-quiz');
      if (!section) return;

      var data = window.NT_QUIZ;
      if (!data || !data.questions || !data.questions.length) return;

      var QUESTIONS = data.questions;
      var DIETS = data.diets;
      var VERSIONS = data.versions;
      var WHY = data.why || {};
      var NOTES = data.notes || {};

      var shell = section.querySelector('[data-nt-quiz]');
      var stage = section.querySelector('[data-nt-quiz-stage]');
      var result = section.querySelector('[data-nt-quiz-result]');
      var count = section.querySelector('[data-nt-quiz-count]');
      var bar = section.querySelector('[data-nt-quiz-bar]');
      var back = section.querySelector('[data-nt-quiz-back]');
      var dataNode = section.querySelector('[data-nt-quiz-variants]');
      if (!shell || !stage || !result || !dataNode) return;

      var variants;
      try {
        variants = JSON.parse(dataNode.textContent);
      } catch (e) {
        return;
      }

      var plansUrl = section.getAttribute('data-nt-plans-url') || '/';
      var disclaimer = section.getAttribute('data-nt-disclaimer') || '';

      shell.hidden = false;

      var step = 0;
      var answers = [];

      function progress() {
        var pct = Math.round((step / QUESTIONS.length) * 100);
        if (bar) bar.style.width = pct + '%';
        if (count) count.textContent = 'Question ' + (step + 1) + ' of ' + QUESTIONS.length;
      }

      function render(moveFocus) {
        var q = QUESTIONS[step];
        progress();

        var html = '<fieldset class=' + attr('nt-quiz__q') + '>';
        html += '<legend class=' + attr('nt-quiz__legend') + ' tabindex=' + attr('-1') + ' data-nt-quiz-legend>' + esc(q.legend) + '</legend>';
        if (q.hint) html += '<p class=' + attr('nt-quiz__hint') + '>' + esc(q.hint) + '</p>';
        html += '<div class=' + attr('nt-quiz__options') + '>';

        for (var i = 0; i < q.options.length; i++) {
          var inputId = 'nt-q-' + q.id + '-' + i;
          html += '<span class=' + attr('nt-quiz__option') + '>';
          html += '<input class=' + attr('nt-quiz__input') + ' type=' + attr('radio') + ' name=' + attr('nt-q-' + q.id) + ' id=' + attr(inputId) + ' value=' + attr(i) + (answers[step] === i ? ' checked' : '') + '>';
          html += '<label class=' + attr('nt-quiz__label') + ' for=' + attr(inputId) + '>' + esc(q.options[i].label) + '</label>';
          html += '</span>';
        }

        html += '</div></fieldset>';
        stage.innerHTML = html;
        stage.hidden = false;

        if (back) back.hidden = step === 0;
        if (moveFocus) {
          var legend = stage.querySelector('[data-nt-quiz-legend]');
          if (legend) legend.focus();
        }
      }

      function score() {
        var diet = {};
        var version = {};
        var flags = {};
        var requires = null;
        var i;
        var key;

        for (i = 0; i < DIETS.length; i++) diet[DIETS[i]] = 0;
        for (i = 0; i < VERSIONS.length; i++) version[VERSIONS[i]] = 0;

        for (i = 0; i < QUESTIONS.length; i++) {
          var chosen = answers[i];
          if (chosen === undefined) continue;
          var option = QUESTIONS[i].options[chosen];
          if (!option) continue;

          if (option.require && diet[option.require] !== undefined) requires = option.require;

          if (option.diet) {
            for (key in option.diet) {
              if (diet[key] !== undefined) diet[key] += option.diet[key];
            }
          }
          if (option.version) {
            for (key in option.version) {
              if (version[key] !== undefined) version[key] += option.version[key];
            }
          }
          if (option.flags) {
            for (var f = 0; f < option.flags.length; f++) flags[option.flags[f]] = true;
          }
        }

        return { diet: diet, version: version, flags: flags, requires: requires };
      }

      function rank(scores, order) {
        var list = order.slice();
        list.sort(function (a, b) {
          if (scores[b] !== scores[a]) return scores[b] - scores[a];
          return order.indexOf(a) - order.indexOf(b);
        });
        return list;
      }

      function firstAvailable(dietOrder, versionName) {
        for (var i = 0; i < dietOrder.length; i++) {
          var row = variants[dietOrder[i]];
          if (row && row[versionName] && row[versionName].available) return dietOrder[i];
        }
        return null;
      }

      function buyForm(id, label) {
        return '<form method=' + attr('post') + ' action=' + attr('/cart/add') + ' class=' + attr('nt-tier__form') + '>' +
          '<input type=' + attr('hidden') + ' name=' + attr('form_type') + ' value=' + attr('product') + '>' +
          '<input type=' + attr('hidden') + ' name=' + attr('id') + ' value=' + attr(id) + '>' +
          '<input type=' + attr('hidden') + ' name=' + attr('quantity') + ' value=' + attr('1') + '>' +
          '<input type=' + attr('hidden') + ' name=' + attr('return_to') + ' value=' + attr('/cart') + '>' +
          '<button type=' + attr('submit') + ' name=' + attr('add') + ' class=' + attr('nt-btn nt-btn--primary nt-btn--full') + '>' + esc(label) + '</button>' +
          '</form>';
      }

      function plansLink(diet, label, style) {
        return '<a class=' + attr('nt-btn ' + style + ' nt-btn--full') + ' href=' + attr(plansUrl + '?diet=' + encodeURIComponent(diet) + '#nt-tiers') + '>' + esc(label) + '</a>';
      }

      function flag(text) {
        return '<p class=' + attr('nt-quiz__flag') + '>' + esc(text) + '</p>';
      }

      function finish() {
        var scored = score();
        var dietOrder = rank(scored.diet, DIETS);
        var versionOrder = rank(scored.version, VERSIONS);
        var topVersion = versionOrder[0];

        var topDiet;
        var constrained = Boolean(scored.requires);

        if (constrained) {
          /* What someone will not eat is a rule, not a preference. It beats
             every score below it, and it beats the medical steer too, because
             pushing meat at a vegetarian is never the safer answer. */
          topDiet = scored.requires;
        } else if (scored.flags.medical) {
          topDiet = 'Balanced';
        } else {
          topDiet = dietOrder[0];
        }

        var runnerUp = null;
        for (var i = 0; i < dietOrder.length; i++) {
          if (dietOrder[i] !== topDiet) {
            runnerUp = dietOrder[i];
            break;
          }
        }

        try {
          window.localStorage.setItem('nt-diet', topDiet);
        } catch (e) {
          /* private browsing, nothing to store */
        }

        var row = variants[topDiet] || {};
        var match = row[topVersion];

        var html = '<p class=' + attr('nt-eyebrow') + '>Your match</p>';
        html += '<p class=' + attr('nt-quiz__match') + ' tabindex=' + attr('-1') + '>' + esc(topDiet) + ', ' + esc(topVersion) + '</p>';
        html += '<p class=' + attr('nt-quiz__why') + '>' + esc(WHY[topDiet] || '') + '</p>';

        if (runnerUp && !constrained) {
          html += '<p class=' + attr('nt-quiz__runner') + '>Second closest was ' + esc(runnerUp) + '. If the match above does not feel right, that is the one to look at next.</p>';
        }

        if (scored.flags.medical) {
          html += flag(constrained ? NOTES.requiredButMedical : NOTES.medical);
        }

        if (scored.flags.vegan) {
          html += flag(NOTES.vegan);
        }

        if (match && match.available) {
          html += '<div class=' + attr('nt-quiz__buy') + '>';
          html += '<p class=' + attr('nt-quiz__price') + '><strong>' + esc(match.price) + '</strong> one payment, yours to keep</p>';
          html += '<div class=' + attr('nt-quiz__actions') + '>';
          html += buyForm(match.id, 'Add this plan to the cart');
          html += plansLink(topDiet, 'Compare all three versions', 'nt-btn--ghost');
          html += '</div></div>';
        } else if (constrained) {
          /* Never quietly swap a vegetarian onto a meat plan just to make a sale. */
          html += flag(topDiet + ' is still being written, so there is nothing here that matches what you eat. Rather than sell you the wrong plan, we would rather you took the free sample and waited for this one.');
        } else {
          var fallback = firstAvailable(dietOrder, topVersion);
          if (fallback) {
            html += flag(topDiet + ' is still being written, so there is nothing to sell you there yet. ' + fallback + ' is the closest one that is ready today.');
            html += '<div class=' + attr('nt-quiz__buy') + '><div class=' + attr('nt-quiz__actions') + '>';
            html += plansLink(fallback, 'See the ' + fallback + ' plans', 'nt-btn--primary');
            html += '</div></div>';
          } else {
            html += flag('Nothing in this plan is on sale at the moment, so there is nothing here to take your money for.');
          }
        }

        html += '<p class=' + attr('nt-quiz__retake') + '><button type=' + attr('button') + ' data-nt-quiz-retake>Start the quiz again</button></p>';

        if (disclaimer) {
          html += '<p class=' + attr('nt-quiz__disclaimer') + '>' + esc(disclaimer) + '</p>';
        }

        stage.hidden = true;
        if (back) back.hidden = true;
        if (count) count.textContent = 'Your result';
        if (bar) bar.style.width = '100%';

        result.innerHTML = html;
        result.hidden = false;

        var heading = result.querySelector('.nt-quiz__match');
        if (heading) heading.focus();
      }

      section.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.classList || !input.classList.contains('nt-quiz__input')) return;
        answers[step] = Number(input.value);

        window.setTimeout(function () {
          if (step < QUESTIONS.length - 1) {
            step += 1;
            render(true);
          } else {
            finish();
          }
        }, 180);
      });

      section.addEventListener('click', function (event) {
        var target = event.target;
        if (!target.closest) return;

        if (target.closest('[data-nt-quiz-back]') && step > 0) {
          step -= 1;
          result.hidden = true;
          result.innerHTML = '';
          render(true);
        }

        if (target.closest('[data-nt-quiz-retake]')) {
          step = 0;
          answers = [];
          result.hidden = true;
          result.innerHTML = '';
          render(true);
        }
      });

      render(false);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-tiers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EVENTS_URL = 'https://cdn.shopify.com/storefront/standard-events.js';

    /* The cart drawer only opens itself when the theme puts an auto-open
       attribute on it, and this theme does not. So after the item is really in
       the cart we ask the drawer to open. If anything at all goes wrong we send
       the visitor to /cart instead, which always works. */
    function drawerEl() {
      return document.querySelector('theme-drawer#cart-drawer');
    }

    function drawerIsOpen() {
      var drawer = drawerEl();
      return Boolean(drawer && drawer.hasAttribute('open'));
    }

    function openDrawer() {
      var drawer = drawerEl();
      if (!drawer || typeof drawer.open !== 'function') return false;
      try {
        drawer.open();
        return true;
      } catch (e) {
        return false;
      }
    }

    function preselectDiet() {
      var wanted = null;
      try {
        wanted = new URLSearchParams(window.location.search).get('diet');
        if (!wanted) wanted = window.localStorage.getItem('nt-diet');
      } catch (e) {
        return;
      }
      if (!wanted) return;

      var radios = document.querySelectorAll('.nt-diet__radio');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value.toLowerCase() === wanted.toLowerCase() && !radios[i].disabled) {
          radios[i].checked = true;
          return;
        }
      }
    }

    function rememberDiet(event) {
      var target = event.target;
      if (!target || !target.classList || !target.classList.contains('nt-diet__radio')) return;
      try {
        window.localStorage.setItem('nt-diet', target.value);
      } catch (e) {
        /* private browsing, nothing to store */
      }
    }

    function handleSubmit(event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('.nt-tier__form')) return;

      var idField = form.querySelector('input[name="id"]');
      if (!idField || !idField.value) return;

      var button = form.querySelector('button[type="submit"]');
      var variantId = idField.value;

      event.preventDefault();
      if (button) button.setAttribute('aria-busy', 'true');

      var settled = false;

      function done() {
        if (settled) return;
        settled = true;
        if (button) button.removeAttribute('aria-busy');
      }

      function giveUp() {
        if (settled) return;
        settled = true;
        window.location.href = '/cart';
      }

      window.setTimeout(giveUp, 6000);

      import(EVENTS_URL)
        .then(function (mod) {
          var CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
          var deferred = CartLinesUpdateEvent.createPromise();

          document.dispatchEvent(
            new CartLinesUpdateEvent({
              source: 'nt-tiers',
              action: 'add',
              lines: [{ merchandiseId: variantId, quantity: 1 }],
              promise: deferred.promise
            })
          );

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('add failed');
              return fetch('/cart.js', { headers: { Accept: 'application/json' } });
            })
            .then(function (response) {
              if (!response.ok) throw new Error('cart read failed');
              return response.json();
            })
            .then(function (cart) {
              deferred.resolve({
                detail: { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), didError: false }
              });

              window.setTimeout(function () {
                if (drawerIsOpen()) {
                  done();
                  return;
                }
                if (openDrawer()) {
                  window.setTimeout(function () {
                    if (drawerIsOpen()) done();
                    else giveUp();
                  }, 400);
                  return;
                }
                giveUp();
              }, 250);
            })
            .catch(function (error) {
              try {
                deferred.reject(error);
              } catch (e) {
                /* already settled */
              }
              giveUp();
            });
        })
        .catch(giveUp);
    }

    function init() {
      preselectDiet();
      document.addEventListener('change', rememberDiet);
      document.addEventListener('submit', handleSubmit);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
